﻿// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple capitalize function.
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        // Simple date object handler.
        toDateObj(dateString) {
            return new Date(dateString);
        },
        // Simple date string handler.
        toDateStr(dateString, language = 'nl-NL') {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            };
            return new Date(dateString).toLocaleDateString(language, options);
        },
        // Simple date string handler for short notation.
        toDateStrShort(dateString, language = 'nl-NL') {
            const options = {
                weekday: 'short',
                month: 'long',
                day: 'numeric'
            };
            return new Date(dateString).toLocaleDateString(language, options);
        },
        // Simple time string handler.
        toTimeStr(dateString, language = 'nl-NL') {
            const options = {
                hour: '2-digit',
                minute: '2-digit'
            };
            const date = new Date(dateString);

            if (date.getFullYear() === 1) {
                const timePart = dateString.split('T')[1];
                const [hour, minute] = timePart.split(':');
                return `${hour}:${minute}`;
            }

            return date.toLocaleTimeString(language, options);
            
        },
        // Simple converter to currency.
        toEuro(value) {
            if (!value) value = 0;
            return new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
            }).format(value);
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        removeDuplicates(array) {
            return [...new Set(array)];
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)}
        }
    }
}

export default mixin;
